module.exports = __webpack_public_path__ + "static/media/lotto5_win.45cfcb1c.mp3";